// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"488":"08a4e32e","640":"51ce055b"}[chunkId] + ".chunk.js";
};